import React, { Component } from 'react';
import { connect } from 'react-redux';
import { string, func, shape, arrayOf, bool, number } from 'prop-types';

import shapeStore from '~constants/propTypes';
import { googleAddressPropTypes } from '~propTypes/address';
import SearchStoreActions from '~redux/SearchStore/actions';
import TabActions from '~redux/Tabs/actions';
import { NEAR_TARGET, DELIVERY_TARGET, ALL_STORES } from '~redux/SearchStore/constants';
import { DISPATCH_METHODS } from '~constants/address';
import { normalizeCoordinates } from '~utils/maps';

import { TABS_DATA } from './constants';
import DeliveryOrPickUp from './layout';

class DeliveryOrPickUpContainer extends Component {
  componentDidMount() {
    const { setTargetValue, onlyPickup } = this.props;

    setTargetValue(`${NEAR_TARGET}Loading`, false);
    setTargetValue(`${DELIVERY_TARGET}Loading`, false);
    if (!onlyPickup) {
      this.findNearbyStores();
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedAddress, changeTab, stores, delivery, onlyPickup, selectedDispatchMethod } = this.props;
    const deliveryStores = Object.keys(delivery || {});
    if (prevProps.selectedAddress !== this.props.selectedAddress && !onlyPickup) {
      this.findNearbyStores();
    }
    if (prevProps.stores !== stores || prevProps.delivery !== delivery) {
      const dispatchMethod =
        (selectedAddress.hasStreetNumber &&
          !!deliveryStores.length &&
          selectedDispatchMethod === DISPATCH_METHODS.DELIVERY) ||
        !stores?.length ||
        stores === null
          ? DISPATCH_METHODS.DELIVERY
          : DISPATCH_METHODS.PICKUP;

      const tabId = TABS_DATA.find((tab) => tab.value === dispatchMethod)?.id;
      changeTab(tabId);
    }
  }

  componentWillUnmount() {
    const { setTargetValue } = this.props;

    setTargetValue(`${NEAR_TARGET}Loading`, true);
    setTargetValue(`${DELIVERY_TARGET}Loading`, true);
  }

  findNearbyStores = () => {
    const { getNearLocation, getStoreDeliveryInfo, selectedAddress } = this.props;
    const location = normalizeCoordinates(selectedAddress);
    const locationWithAddress = {
      ...location,
      address: selectedAddress.textAddress,
      googlePlaceId: selectedAddress.placeId
    };
    getNearLocation(locationWithAddress);
    getStoreDeliveryInfo(locationWithAddress);
  };

  handleStoreSelect = ({ store }) => {
    const { onAddressSelect, onlyPickup, onStoreSelect } = this.props;
    if (onlyPickup) {
      onAddressSelect({
        addressData: {
          latitude: store.latitude,
          longitude: store.longitude,
          description: store.textAddress,
          textAddress: store.textAddress,
          commune: store.textAddress,
          city: store.textAddress
        },
        onlyPickup: true
      });
    }
    onStoreSelect?.({ store });
  };

  handleConfirm = ({ store, addressDetails, type }) => {
    const { onConfirm, selectedStore } = this.props;
    const dispatchMethod = type;
    onConfirm({
      store: store || selectedStore,
      addressDetails,
      type: dispatchMethod
    });
  };

  render() {
    const {
      loading,
      stores,
      storesError,
      selectedAddress,
      delivery,
      deliveryError,
      onlyPickup,
      allStores,
      selectedStore
    } = this.props;

    return (
      <DeliveryOrPickUp
        selectedAddress={selectedAddress}
        stores={stores}
        allStores={allStores}
        storesError={storesError}
        delivery={delivery}
        deliveryError={deliveryError}
        selectedStore={selectedStore}
        onStoreSelect={this.handleStoreSelect}
        onConfirm={this.handleConfirm}
        loading={loading}
        onlyPickup={onlyPickup}
      />
    );
  }
}

DeliveryOrPickUpContainer.propTypes = {
  changeTab: func.isRequired,
  getNearLocation: func.isRequired,
  getStoreDeliveryInfo: func.isRequired,
  setTargetValue: func.isRequired,
  onAddressSelect: func.isRequired,
  onConfirm: func.isRequired,
  allStores: arrayOf(shapeStore),
  delivery: shape({
    name: string,
    deliveryWaitTime: number,
    menuId: number
  }),
  deliveryError: string,
  loading: bool,
  onlyPickup: bool,
  selectedAddress: googleAddressPropTypes,
  selectedDispatchMethod: string,
  selectedStore: shape(shapeStore),
  stores: arrayOf(shapeStore),
  storesError: string,
  onStoreSelect: func
};

const mapStateToProps = (state) => ({
  delivery: state.searchStore[DELIVERY_TARGET],
  deliveryError: state.searchStore[`${DELIVERY_TARGET}Error`],
  stores: state.searchStore[NEAR_TARGET],
  allStores: state.searchStore[ALL_STORES],
  storesError: state.searchStore[`${NEAR_TARGET}Error`],
  loading: state.searchStore[`${NEAR_TARGET}Loading`] || state.searchStore[`${DELIVERY_TARGET}Loading`]
});

const mapDispatchToProps = (dispatch) => ({
  changeTab: (newTabId) => dispatch(TabActions.changeTab(newTabId)),
  getNearLocation: (location) => dispatch(SearchStoreActions.getNear(location)),
  getStoreDeliveryInfo: (location) => dispatch(SearchStoreActions.getStoreDelivery(location)),
  setTargetValue: (target, payload) => dispatch(SearchStoreActions.setValue(target, payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOrPickUpContainer);
